module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users-hours text-dark"
  }, [_c('div', {
    staticClass: "users-hours__header"
  }, [_c('div', {
    staticClass: "users-hours__header__left"
  }, [_c('h1', {
    staticClass: "marg-20-right"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assign_hours')))]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  }), _vm._v(" "), (!_vm.isInitalLoad) ? _c('p', {
    staticClass: "marg-10-left"
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.showing_scheduled_hours_from')) + " " + _vm._s(_vm._f("yearFormat")(_vm.startDate)) + " - " + _vm._s(_vm._f("yearFormat")(_vm.endDate)))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "user-tasks__header__right"
  }, [(!_vm.isDatesPristine) ? _c('p', {
    staticClass: "d-link",
    on: {
      "click": _vm.resetDates
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), (_vm.activeSchoolYear) ? _c('DatePickerRangeShortcuts', {
    staticClass: "marg-1-right",
    attrs: {
      "startDate": _vm.activeSchoolYear.employee_time_start,
      "endDate": _vm.activeSchoolYear.employee_time_end,
      "selectedStartDate": _vm.startDate,
      "selectedEndDate": _vm.endDate
    },
    on: {
      "shortcutSelected": _vm.setDatesFromRange
    }
  }) : _vm._e(), _vm._v(" "), _c('DatePickerRange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": function($event) {
        return _vm.setEndDate($event, true)
      }
    }
  }), _vm._v(" "), (_vm.isShowPrintButton) ? _c('button', {
    staticClass: "marg-1-left",
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "users border"
  }, [(_vm.isLoadingUpdatedNumbers && !_vm.isInitalLoad && !this.numberOfWorkDaysInPeriod) ? _c('div', {
    staticClass: "users--loading"
  }, [_c('Spinner', {
    attrs: {
      "bg-color": "#fff"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "users-header users-header-second"
  }, [_c('div', {
    staticClass: "flex-left"
  }, [_c('div', {
    staticClass: "users-user__meta"
  }, [_c('div', [_c('input', {
    staticClass: "users-header__searchfield",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('vue2.assign_users_hours.search_a_name')
    },
    on: {
      "input": _vm.debounceSearch
    }
  })]), _vm._v(" "), _c('filterTags', {
    staticClass: "marg-1-left",
    attrs: {
      "users": _vm.usersForList,
      "schoolid": _vm.schoolId,
      "tags": _vm.tags,
      "selectedTags": _vm.appliedFilters
    },
    on: {
      "set": _vm.setTagFromFilter,
      "remove": _vm.removeTagFromFilter
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-right users-header-second__buttons"
  }, [(_vm.isShowPrintTaskOverviewModal) ? _c('PrintTaskOverviews', {
    attrs: {
      "tags": _vm.tags,
      "theUserCanManageAssignedHours": _vm.theUserCanManageAssignedHours,
      "schoolThresholdToHideTaskHours": _vm.schoolThresholdToHideTaskHours
    },
    on: {
      "close": function($event) {
        _vm.isShowPrintTaskOverviewModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowSaveVersionTaskOverviewModal) ? _c('SaveTaskOverview', {
    on: {
      "close": function($event) {
        _vm.isShowSaveVersionTaskOverviewModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('AssignHoursNorm', {
    attrs: {
      "prepFactor": _vm.schoolPrepFactor,
      "isLocalPoolActivated": _vm.isLocalPoolActivated,
      "isPoolsDeactivated": _vm.isPoolsDeactivated,
      "isKindergarten": false,
      "tags": _vm.tags
    },
    on: {
      "updateUsersHours": _vm.getUsersHours
    }
  }) : _vm._e(), _vm._v(" "), _c('DDropdown', {
    attrs: {
      "isShowDots": false,
      "isBottomStart": false,
      "propOffset": [5, 5]
    }
  }, [_c('button', {
    staticClass: "do-bttn",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "icon-more2"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [(_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.setIsDeactivatePoolsModalVisible(true)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isPoolsDeactivated ? 'Aktiver puljer' : 'Deaktiver puljer') + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.setIsChangePrepFactorModal(true)
      }
    }
  }, [_vm._v("\n              " + _vm._s(!_vm.schoolPrepFactor ? 'Aktiver forbereldesesfaktor' : 'Forberedelsesfaktor ' + _vm.schoolPrepFactor) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.isShowTaskOverviewSettings = true
      }
    }
  }, [_vm._v("\n              Design opgaveoversigter\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.isShowSaveVersionTaskOverviewModal = true
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.task_versions.save_new_version_task_overviews')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.theUserCanManageAssignedHours) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.isShowPrintTaskOverviewModal = true
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.task_versions.print_latest_version_task_overviews')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.asyncLoadXLSXAndDownload
    }
  }, [_vm._v("\n              " + _vm._s(_vm.i18n['download_to_excel']) + "\n            ")]), _vm._v(" "), (_vm.isSchoolFromCO) ? _c('li', {
    on: {
      "click": _vm.setIsChangeViewModal
    }
  }, [_vm._v(_vm._s(_vm.i18n['change_view']))]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateUserHours
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.assign_users_hours.update')) + "\n            ")]), _vm._v(" "), (_vm.isSchoolDanish) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.setIsShowEmploymentEnded(true)
      }
    }
  }, [_vm._v("\n              Brudt ansættelse\n            ")]) : _vm._e()])])], 1)]), _vm._v(" "), (_vm.isInitalLoad || _vm.isLoadingSubjectsOrTasks) ? _c('div', {
    staticStyle: {
      "margin": "100px auto"
    }
  }, [_c('Spinner', {
    attrs: {
      "bgColor": "#fff"
    }
  })], 1) : _c('AllUsers', {
    attrs: {
      "theUserCanManageAssignedHours": _vm.theUserCanManageAssignedHours,
      "prepFactor": _vm.schoolPrepFactor,
      "viewSettings": _vm.viewSettings,
      "schoolid": _vm.schoolId,
      "users": _vm.filteredUsers,
      "isDatesPristine": _vm.isDatesPristine,
      "numberOfWorkDays": _vm.numberOfWorkDays,
      "numberOfWorkDaysInPeriod": _vm.numberOfWorkDaysInPeriod,
      "isLocalPoolActivated": _vm.isLocalPoolActivated,
      "locale": _vm.locale,
      "isPoolsDeactivated": _vm.isPoolsDeactivated
    },
    on: {
      "setActiveUser": _vm.setActiveUser,
      "setTheUserToShowTasks": _vm.setTheUserToShowTasks,
      "updatedUser": _vm.updatedUser
    }
  })], 1), _vm._v(" "), (_vm.isChangeViewModal) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "show-close": false
    },
    on: {
      "close": _vm.setIsChangeViewModal
    }
  }, [_c('div', {
    staticClass: "modal-assign-hours-view",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "do-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['change_view']))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": _vm.setIsChangeViewModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__body"
  }, [_c('ul', _vm._l((_vm.viewSettingsI18N), function(setting, key) {
    return _c('li', {
      key: key,
      staticClass: "modal-assign-hours-view__item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setViewSetting(key, setting.active)
        }
      }
    }, [_c('label', {
      staticClass: "d-label"
    }, [_vm._v(_vm._s(setting.title))]), _vm._v(" "), _c('div', {
      staticClass: "do-switch",
      class: {
        'do-switch--active': setting.active
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__footer"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.setIsChangeViewModal
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.done')))])])])]) : _vm._e(), _vm._v(" "), (_vm.activeUserId) ? _c('ShowUserAbsence', {
    attrs: {
      "eventsFilter": _vm.activeUserEventFilter,
      "userId": _vm.activeUserId
    },
    on: {
      "close": function($event) {
        _vm.activeUserId = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "show-close": false
    },
    on: {
      "close": _vm.closeTheUserToShowTasks
    }
  }, [_c('div', {
    staticClass: "user-task__container",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "user-task__container__header"
  }, [_c('h2'), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": _vm.closeTheUserToShowTasks
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('UserTasks', {
    attrs: {
      "initialStartDate": _vm.startDate,
      "initialEndDate": _vm.endDate,
      "user_id": _vm.theUserToShowTasks.id,
      "user_calendar_id": _vm.theUserToShowTasks.user_calendar_id,
      "user_name": _vm.theUserToShowTasks.name,
      "isShowPrintButton": false,
      "isCanSeeOtherUsers": false
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isChangePrepFactorModal) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "show-close": false
    },
    on: {
      "close": function($event) {
        return _vm.setIsChangePrepFactorModal(false)
      }
    }
  }, [_c('div', {
    staticClass: "do-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "do-modal__header"
  }, [_c('h2', [_vm._v("Forberedelsesfaktor")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.setIsChangePrepFactorModal(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__body"
  }, [_c('div', {
    staticClass: "d-explainer-box text-explainer text-explainer__error"
  }, [_c('svg', {
    staticClass: "tw-icon icon-help",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z"
    }
  })]), _vm._v("\n          Aktivering af forberedelsesfaktor gør, at timer til forberedelse automatisk opdateres, når undervisning\n          tildeles til en underviser.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-label-and-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setIsThePrepFactorActive.apply(null, arguments)
      }
    }
  }, [_c('label', {
    staticClass: "d-label color-dark"
  }, [_vm._v("Aktiver forberedelsesfaktor")]), _vm._v(" "), _c('div', {
    staticClass: "do-switch",
    class: {
      'do-switch--active': _vm.isThePrepFactorActive
    }
  })]), _vm._v(" "), (_vm.isThePrepFactorActive) ? _c('div', {
    staticClass: "prep-factor-input marg-1-bottom"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Indtast jeres forberedelsesfaktor")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thePrepFactor),
      expression: "thePrepFactor"
    }],
    ref: "the_prep_factor_input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.thePrepFactor)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.savePrepFactor.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thePrepFactor = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__footer"
  }, [_c('button', {
    staticClass: "do-bttn marg-1-right",
    on: {
      "click": function($event) {
        return _vm.setIsChangePrepFactorModal(false)
      }
    }
  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSavingPrepFactor
    },
    on: {
      "click": _vm.savePrepFactor
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isShowEmploymentEnded) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "show-close": false
    },
    on: {
      "close": function($event) {
        return _vm.setIsShowEmploymentEnded(false)
      }
    }
  }, [_c('div', {
    staticClass: "do-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "do-modal__header"
  }, [_c('h2', [_vm._v("Brudt ansættelse")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.setIsShowEmploymentEnded(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__body"
  }, [_c('AssignHoursEmploymentEnded', {
    attrs: {
      "schoolId": _vm.schoolId,
      "users": _vm.usersForList
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isShowTaskOverviewSettings) ? _c('TaskOverviewSettings', {
    on: {
      "close": function($event) {
        _vm.isShowTaskOverviewSettings = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDeactivatePoolsModalVisible) ? _c('AssignHoursDeactivatePoolsModal', {
    attrs: {
      "isPoolsDeactivated": _vm.isPoolsDeactivated
    },
    on: {
      "reReadNumbers": _vm.reReadNumbers,
      "close": function($event) {
        return _vm.setIsDeactivatePoolsModalVisible(false)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5960870a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHours.vue
// module id = 1595
// module chunks = 1